import { memo } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { WebRoutes } from "consts/enpoints/web";
import CustomBreadcrumbs from "lib/custom-breadcrumbs";
import { Link, Outlet, useLocation } from "infrastructure/router";

const MERCHANT_PATH = WebRoutes.KYCSettings.MerchantKYCSettings.Index;
const PSP_PATH = WebRoutes.KYCSettings.PSPKYCSettings.Index;

const isUnder = (pathname: string, path: string) =>
    pathname === path || pathname.startsWith(`${path}/`);

const KYCSettingsLayout = () => {
    const { pathname } = useLocation();

    const activeValue = isUnder(pathname, PSP_PATH) ? PSP_PATH : MERCHANT_PATH;
    const leafLabel = activeValue === PSP_PATH ? 'PSP' : 'Merchant';

    return (
        <Box sx={{ px: '20px' }}>
            <CustomBreadcrumbs
                sx={{ mb: 2 }}
                links={[
                    { name: 'Management' },
                    { name: 'KYC Settings', href: WebRoutes.KYCSettings.Index },
                    { name: leafLabel }
                ]}
            />

            <Tabs
                value={activeValue}
                sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
            >
                <Tab
                    label='Merchant KYC Settings'
                    value={MERCHANT_PATH}
                    component={Link}
                    to={MERCHANT_PATH}
                    data-test-id='kycSettings.tab.merchant'
                />
                <Tab
                    label='PSP KYC Settings'
                    value={PSP_PATH}
                    component={Link}
                    to={PSP_PATH}
                    data-test-id='kycSettings.tab.psp'
                />
            </Tabs>

            <Outlet />
        </Box>
    );
};

export default memo(KYCSettingsLayout);
